import { TimelineItem } from './types';

// The API returns a numeric id; coerce to string to match TimelineItem.id and the ids used in URLs.
export const normalizeTimelineId = (timeline: TimelineItem): TimelineItem => (
    { ...timeline, id: String(timeline.id) }
);
